export { default, default as SimpleSkeletonLoader } from './SimpleSkeletonLoader'
export { default as simpleSkeletonLoaderTheme } from './themes/SimpleSkeletonLoader.theme'
export * as SimpleSkeletonLoaderStyles from './styles/SimpleSkeletonLoader.style'

export type { SimpleSkeletonLoaderProps } from './SimpleSkeletonLoader.types'
export type { AppearanceKeys, SimpleSkeletonLoaderTheme } from './themes/SimpleSkeletonLoader.theme.types'
export type { StyledSimpleSkeletonLoaderProps } from './styles/SimpleSkeletonLoader.style.types'
